<template>
  <div>
    <router-view name="dialog"/>
    <transition name="fade">
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  beforeDestroy() {
    this.$store.dispatch('destroyCurrentProgram');
  },
};
</script>

<style lang="scss" scoped>
</style>
